import React from "react";
import {Box, Grid, Input, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    labelCaption: (props: any) => ({
        '&.MuiTypography-root': {
            fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
            fontWeight: props.isBold ? `bold` : `normal`,
            fontFamily: `revert`
        }
    }),
    inputStyles: (props: any) => ({
        width: `100%`,
        // lineHeight: `1`,
        // backgroundColor: '#ffffff',
        border: props.readonly && !props.isMultiplyRows ? `none` : `1px solid #888888`,
        backgroundColor: `white`,
        borderRadius: "5px",
        "&.MuiInputBase-multiline": {
            padding: `0`,
        },
        "&.MuiInput-root": {
            '& > input': {
                fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                padding: props.withoutPadding && props.readonly ? `0` : `6px`,
                direction: props.direction,
                color: props.readonly ? `#A2A2A2` : `#000000`,
                // lineHeight: `1`,
            },
            '& > textarea': {
                fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                padding: props.withoutPadding && props.readonly ? `0` : `5px`,
                direction: props.direction,
                color: props.readonly ? `#A2A2A2` : `#000000`,
                // lineHeight: `1`,
            }
        },
        "&.requiredField": {
            borderLeft: `4px solid #E5870E`,
            borderRadius: `0 5px 5px 0`,
        },
        "&.notValid": {
            borderLeftColor: `red`,
        },
        "&.Mui-disabled": {
            backgroundColor: `#dbdbdb`,
        },
    }),
}))


interface Props {
    labelGridSizeNumber?: number;
    inputGridSizeNumber?: number;
    valueForInput?: string;
    onChangeInput?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    labelCaption?: string | null;
    labelAlign?: `start` | `end` | `center`;
    fontSize?: string;
    isBold?: boolean;
    fieldName?: string;
    maxLength?: number;
    readonly?: boolean;
    isRequired?: boolean;
    isNotValid?: boolean;
    isDisabled?: boolean;
    rows?: number;
    direction?: `rtl` | `ltr`;
    withoutPadding?: boolean;
    type?: string;
}

export const TextInputWithLabel: React.FC<Props> = ({
                                                        labelGridSizeNumber,
                                                        inputGridSizeNumber,
                                                        valueForInput,
                                                        onChangeInput,
                                                        labelCaption,
                                                        labelAlign,
                                                        fontSize,
                                                        isBold,
                                                        fieldName,
                                                        maxLength,
                                                        readonly,
                                                        isRequired,
                                                        isNotValid,
                                                        isDisabled,
                                                        rows,
                                                        direction,
                                                        withoutPadding,
                                                        type = "text"
                                                    }) => {
    const properties = {
        fontSize: fontSize ? fontSize : `14`,
        isBold: isBold ? isBold : '400',
        readonly: readonly ? readonly : false,
        direction: direction === `rtl` ? `rtl` : `ltr`,
        isMultiplyRows: !!rows,
        withoutPadding: withoutPadding ? withoutPadding : false
    }
    const classes = useStyles(properties);

    return (
        <>
            {
                labelCaption &&
                <Grid item {...(labelGridSizeNumber ? {xs: labelGridSizeNumber} : {xs: true})}>
                    <Typography className={classes.labelCaption} textTransform={`capitalize`}
                                textAlign={labelAlign ? labelAlign : 'start'}>
                        {labelCaption}
                    </Typography>
                </Grid>
            }
            <Grid item {...(inputGridSizeNumber ? {xs: inputGridSizeNumber} : {xs: true})}>
                <Box sx={{display: `flex`}}>
                    <Input
                        {...(rows ? {multiline: true} : {})}
                        disableUnderline
                        className={`${classes.inputStyles} ${isRequired && !readonly ? `requiredField` : ''} ${isNotValid ? 'notValid' : ''}`}
                        name={fieldName ? fieldName : ''}
                        value={valueForInput}
                        onChange={onChangeInput}
                        disabled={isDisabled ? isDisabled : false}
                        inputProps={{maxLength: maxLength ? maxLength : 100}}
                        readOnly={readonly ? readonly : false}
                        rows={rows ? rows : 1}
                        type={type}
                    />
                </Box>
            </Grid>
        </>
    )
}